export class funciones {
    
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static eliminarValorDeArray(array , campo, valor){
        var noHayMas=true;
        while (noHayMas) {
            noHayMas=false;
            var indice=-1, indiceActual=-1;
            array.forEach(filaActual => {
                indice++;
                if (filaActual[campo]==valor){
                    indiceActual=indice;
                }
            });
            if (indiceActual!=-1){
                array.splice(indiceActual,1);
                noHayMas=true;
            }
        }
        return array;
    };

    static eliminarAcentos(str)
    {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, ""); 
    }

    static esNumero(str) {
        var parsed = parseFloat(str);
        var casted = +str;
        return parsed === casted  && !isNaN(parsed) && !isNaN(casted);
    }

    static existeValorEnArray(array, columna, valor){
        return array.some(function(el){ return el[columna] === valor});
    }
}